export default __webpack_public_path__ + "static/media/mountain-bike.ce9d4482.jpg";